import { createStore, combineReducers, Store } from 'redux';
import { formReducer } from './formReducer';
import { IWithForms } from '../types';

const rootReducer = combineReducers({ forms: formReducer });

export const formStore: Store<IWithForms> = createStore(rootReducer);
